// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#overlay {
  background: #ffffff;
  color: #666666;
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 5000;
  top: 0;
  left: 0;
  float: left;
  text-align: center;
  padding-top: 25%;
  opacity: .80;
}

mat-form-field.mat-form-field {
  width:150px;
}

.toBack {
   z-index: 5000;
   background-color: #666666;

}
.dotSelected {
  z-index: 5000;
  background-color: #666666;
  height: 40px;
  width: 40px;
  border-radius: 50%;
        padding: 10px;
        display: flex;
}

.dotYellow {
  background-color: #FFFF66;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
}

.dotGreen {
  background-color: lightgreen;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
}

.dotRed {
  background-color: lightcoral;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
}

.dotBlue {
  background-color: lightskyblue;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
}

.dotGray {
  background-color: lightslategray;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
}

.dotOrange {
  background-color: orange;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
}

.dotPurple {
  background-color: purple;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
}

.dotBrown {
  background-color: burlywood;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
}



.dotDarkBlue {
  background-color: darkblue;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
}
.dotBlack {
  background-color: black;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
}
table {
  width: 100%;
}
mat-form-field {
  width: 100%;
}
.mat-card{
  position: fixed;
  z-index: 1;
  width: 100%;
}
button:focus, button:active:focus, button.active:focus {
  outline: none !important;
  outline-style: none !important;
  border: 0;
  }


:focus {
  outline: none !important;
  outline-style: none !important;
  border: 0;
}

mat-paginator {
  outline: none !important;
  outline-style: none !important;
  border: 0;
}

.padLeft  {
  padding-left: 10px;
}

@media(max-width: 900px){
  .hiddenMobile {
    display: none;
  }
    /* filter date */
  .dateFilter {
    width: 170px;
  }
  .searchFilter {
    width: 100%;
  }
}

@media(max-width: 900px){

    /* filter date */
  .hideFilterSmallDevice {
    display: none;
  }

  .mat-column-textMobile {
    width: 30% !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-right: 10px;
  }

  .mat-column-partnerTitleSmall {
    width: 20%;
    padding-right: 10px;
  }
  /* to naredi ellipsis*/
  th {
    text-overflow: ellipsis;
  }
  table {
    width: 100%;
    table-layout: fixed;
  }
  .mat-column-uredi {
    overflow: hidden;
    width:auto;
    white-space: nowrap;
  }

  td.mat-cell:first-of-type, td.mat-footer-cell:first-of-type, th.mat-header-cell:first-of-type {
    padding-left: 0px;
}
}

@media(min-width: 900px){

  /* filter date */
.hideFilterBigDevice {
  display: none;
}

.mat-column-text {
  width: 27% !important;
  text-overflow: ellipsis;
  overflow: hidden;
  width:auto;
  white-space: nowrap;
  padding-right: 10px;
}


.mat-column-statusNameSmall {
  width: 7% !important;
  overflow: hidden;
  width:auto;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: 10px;
}

.mat-column-tsEvent {
  width: 9% !important;
  overflow: hidden;
  width:auto;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: 10px;
}

.mat-column-tsBooked {
  width: 10% !important;
  overflow: hidden;
  width:auto;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: 10px;
}

.mat-column-statusColor {
  width: 5% !important;
  overflow: hidden;
  width:auto;
  white-space: nowrap;
  padding-right: 10px;
}

.mat-column-partnerTitleSmall {
  width: 10% !important;
  overflow: hidden;
  width:auto;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: 10px;
}
.mat-column-partnerCode {
  width: 8% !important;
  overflow: hidden;
  width:auto;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: 10px;
}
.mat-column-nextContact {
  width: 7% !important;
  overflow: hidden;
  width:auto;
  text-overflow: ellipsis;
  padding-right: 10px;
}

.mat-column-buildInSolution {
  width: 5% !important;
  overflow: hidden;
  width:auto;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: 10px;
}
.mat-column-uredi {
  overflow: hidden;
  width:auto;
  white-space: nowrap;
}
.mat-column-workCodeCurrent {
  width: 5% !important;
  overflow: hidden;
  width:auto;
  white-space: nowrap;
  padding-right: 10px;
}

.mat-column-cooperationNameSmall {
  width: 7% !important;
  overflow: hidden;
  width:auto;
  white-space: nowrap;
  padding-right: 10px;
}

.mat-column-numberOfUnreadMessages {
  width: 10% !important;
  padding-right: 10px;
}

.mat-column-workFirstNameCurrent {
  width: 5% !important;
  text-overflow: ellipsis;
  overflow: hidden;
  width:auto;
  white-space: nowrap;
  padding-right: 10px;
}
.mat-column-timespendMin {
  width: 5% !important;
  text-overflow: ellipsis;
  overflow: hidden;
  width:auto;
  white-space: nowrap;
  padding-right: 10px;
}

.mat-column-toProcessButton, .mat-column-uredi,
.mat-column-addDaysButton, .mat-column-toHelpdeskTabButton{
  width: 40px !important;
  padding-right: 10px;
}
.mat-column-completed {
  width: 4% !important;
  text-overflow: ellipsis;
  overflow: hidden;
  width:auto;
  white-space: nowrap;
  padding-right: 10px;
}

th {
  text-overflow: ellipsis;
}
table {
  width: 100%;
  table-layout: fixed;
}
}
@media(min-width: 900px){
  .hiddenDesktop {
    display: none;
  }
    /* filter date */
  .dateFilter {
    width: 250px;
  }
}



/*filter icons*/
#filterIconCross {
  display: inline-block;
  width: 30px !important;
  height: 20px;
  transform: rotate(0deg);
  transition: .5s ease-in-out;
  cursor: pointer;
}
#filterIconCross span {
  position: absolute;
  height: 3px;
  width: 20px;
  background: lightcoral;
  border-radius: 9px;
  opacity: 1;
  left: 0;
  transform: rotate(0deg);
  transition: .25s ease-in-out;
}
#filterIconCross span:nth-child(1) {
  transform: rotate(135deg);
}

#filterIconCross span:nth-child(2) {
  transform: rotate(-135deg);
}


.buttonBilumina {
  background-color:#f89624;
  color:white;
  margin: 10px;
  width:90px;
}

/*table coloring*/
#mainTable .mat-row:nth-child(odd){
  background-color:#FFF5E3;
  }

/*table coloring*/
#mainTable .mat-row:nth-child(even){
  background-color:#ffe8bf;
  }
#mainTable .mat-row:nth-child(odd):hover{
  transition: 0.3s;
  background-color:#fffcf7;
  }

#mainTable .mat-row:nth-child(even):hover{
  transition: 0.3s;
  background-color:#ffeed0;
  }

mat-paginator {
  background-color:#FAB565;
}

.mat-checkbox-inner-container {
  background-color: #f89624;
}

#mainTable .mat-header-cell {
  background-color: #f89624;
  font-size: 16px;
  text-align: center;
  color: rgb(33, 29, 22);
}

p:hover {
  cursor: pointer;
}

.checkStatusColor {
  color: #929089;
}

#overlay {
  background: #ffffff;
  color: #666666;
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 5000;
  top: 0;
  left: 0;
  float: left;
  text-align: center;
  padding-top: 25%;
  opacity: .80;
}

.bold {
  font-weight: bold;
}

.numReadMessages {
  background-color: #ffb2b2  !important; /*thistle*/
}

.hidePartner {
  display: none;
}

.mat-column-textPartner {
  width: 30% !important;
  text-overflow: ellipsis;
  overflow: hidden;
  width:auto;
  white-space: nowrap;
  padding-right: 10px;
}

.mat-column-communicationTypeNameSmall {
  width: 7% !important;
  text-overflow: ellipsis;
  overflow: hidden;
  width:auto;
  white-space: nowrap;
  padding-right: 10px;
}
.mat-column-todoCode {
  width: 7% !important;
  text-overflow: ellipsis;
  overflow: hidden;
  width:auto;
  white-space: nowrap;
  padding-right: 10px;
}

.mat-column-select {
  width: 20% !important;
  overflow: hidden;
  width:auto;
  white-space: nowrap;
  padding-right: 10px;
}

.mat-column-code {
  width: 80% !important;
  overflow: hidden;
  text-overflow: ellipsis;
  width:auto;
  white-space: nowrap;
  padding-right: 10px;
}
.statusPaddingSmallScreen {
  padding-bottom: 15px;
}

.example-radio-group {
  display: flex;
  flex-direction: column;
  margin: 15px 0;
}

tr.mat-header-row {
  height: 40px !important;
}

.cdk-overlay-pane {
  position: fixed !important;
}

`, "",{"version":3,"sources":["webpack://./src/app/HELPDESK/pregled-helpdeska/pregled-helpdeska.component.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,MAAM;EACN,OAAO;EACP,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;GACG,aAAa;GACb,yBAAyB;;AAE5B;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,kBAAkB;QACZ,aAAa;QACb,aAAa;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;;;AAIA;EACE,0BAA0B;EAC1B,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,UAAU;EACV,WAAW;AACb;AACA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,SAAS;EACT;;;AAGF;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;EACf;IACE,gBAAgB;EAClB;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;AACF;;AAEA;;IAEI,gBAAgB;EAClB;IACE,aAAa;EACf;;EAEA;IACE,qBAAqB;IACrB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;EACA,sBAAsB;EACtB;IACE,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;AACrB;AACA;;AAEA;;EAEE,gBAAgB;AAClB;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,mBAAmB;AACrB;;;AAGA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,UAAU;EACV,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,UAAU;EACV,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,UAAU;EACV,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,UAAU;EACV,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,UAAU;EACV,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,UAAU;EACV,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,UAAU;EACV,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;AACA;EACE;IACE,aAAa;EACf;IACE,gBAAgB;EAClB;IACE,YAAY;EACd;AACF;;;;AAIA,eAAe;AACf;EACE,qBAAqB;EACrB,sBAAsB;EACtB,YAAY;EAIZ,uBAAuB;EAIvB,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,OAAO;EAIP,uBAAuB;EAIvB,4BAA4B;AAC9B;AACA;EAIE,yBAAyB;AAC3B;;AAEA;EAIE,0BAA0B;AAC5B;;;AAGA;EACE,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA,iBAAiB;AACjB;EACE,wBAAwB;EACxB;;AAEF,iBAAiB;AACjB;EACE,wBAAwB;EACxB;AACF;EACE,gBAAgB;EAChB,wBAAwB;EACxB;;AAEF;EACE,gBAAgB;EAChB,wBAAwB;EACxB;;AAEF;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,MAAM;EACN,OAAO;EACP,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qCAAqC,EAAE,UAAU;AACnD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,UAAU;EACV,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":["#overlay {\n  background: #ffffff;\n  color: #666666;\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  z-index: 5000;\n  top: 0;\n  left: 0;\n  float: left;\n  text-align: center;\n  padding-top: 25%;\n  opacity: .80;\n}\n\nmat-form-field.mat-form-field {\n  width:150px;\n}\n\n.toBack {\n   z-index: 5000;\n   background-color: #666666;\n\n}\n.dotSelected {\n  z-index: 5000;\n  background-color: #666666;\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n        padding: 10px;\n        display: flex;\n}\n\n.dotYellow {\n  background-color: #FFFF66;\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.dotGreen {\n  background-color: lightgreen;\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.dotRed {\n  background-color: lightcoral;\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.dotBlue {\n  background-color: lightskyblue;\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.dotGray {\n  background-color: lightslategray;\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.dotOrange {\n  background-color: orange;\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.dotPurple {\n  background-color: purple;\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.dotBrown {\n  background-color: burlywood;\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n\n\n.dotDarkBlue {\n  background-color: darkblue;\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n}\n.dotBlack {\n  background-color: black;\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n}\ntable {\n  width: 100%;\n}\nmat-form-field {\n  width: 100%;\n}\n.mat-card{\n  position: fixed;\n  z-index: 1;\n  width: 100%;\n}\nbutton:focus, button:active:focus, button.active:focus {\n  outline: none !important;\n  outline-style: none !important;\n  border: 0;\n  }\n\n\n:focus {\n  outline: none !important;\n  outline-style: none !important;\n  border: 0;\n}\n\nmat-paginator {\n  outline: none !important;\n  outline-style: none !important;\n  border: 0;\n}\n\n.padLeft  {\n  padding-left: 10px;\n}\n\n@media(max-width: 900px){\n  .hiddenMobile {\n    display: none;\n  }\n    /* filter date */\n  .dateFilter {\n    width: 170px;\n  }\n  .searchFilter {\n    width: 100%;\n  }\n}\n\n@media(max-width: 900px){\n\n    /* filter date */\n  .hideFilterSmallDevice {\n    display: none;\n  }\n\n  .mat-column-textMobile {\n    width: 30% !important;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    padding-right: 10px;\n  }\n\n  .mat-column-partnerTitleSmall {\n    width: 20%;\n    padding-right: 10px;\n  }\n  /* to naredi ellipsis*/\n  th {\n    text-overflow: ellipsis;\n  }\n  table {\n    width: 100%;\n    table-layout: fixed;\n  }\n  .mat-column-uredi {\n    overflow: hidden;\n    width:auto;\n    white-space: nowrap;\n  }\n\n  td.mat-cell:first-of-type, td.mat-footer-cell:first-of-type, th.mat-header-cell:first-of-type {\n    padding-left: 0px;\n}\n}\n\n@media(min-width: 900px){\n\n  /* filter date */\n.hideFilterBigDevice {\n  display: none;\n}\n\n.mat-column-text {\n  width: 27% !important;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  width:auto;\n  white-space: nowrap;\n  padding-right: 10px;\n}\n\n\n.mat-column-statusNameSmall {\n  width: 7% !important;\n  overflow: hidden;\n  width:auto;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding-right: 10px;\n}\n\n.mat-column-tsEvent {\n  width: 9% !important;\n  overflow: hidden;\n  width:auto;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding-right: 10px;\n}\n\n.mat-column-tsBooked {\n  width: 10% !important;\n  overflow: hidden;\n  width:auto;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding-right: 10px;\n}\n\n.mat-column-statusColor {\n  width: 5% !important;\n  overflow: hidden;\n  width:auto;\n  white-space: nowrap;\n  padding-right: 10px;\n}\n\n.mat-column-partnerTitleSmall {\n  width: 10% !important;\n  overflow: hidden;\n  width:auto;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding-right: 10px;\n}\n.mat-column-partnerCode {\n  width: 8% !important;\n  overflow: hidden;\n  width:auto;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding-right: 10px;\n}\n.mat-column-nextContact {\n  width: 7% !important;\n  overflow: hidden;\n  width:auto;\n  text-overflow: ellipsis;\n  padding-right: 10px;\n}\n\n.mat-column-buildInSolution {\n  width: 5% !important;\n  overflow: hidden;\n  width:auto;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding-right: 10px;\n}\n.mat-column-uredi {\n  overflow: hidden;\n  width:auto;\n  white-space: nowrap;\n}\n.mat-column-workCodeCurrent {\n  width: 5% !important;\n  overflow: hidden;\n  width:auto;\n  white-space: nowrap;\n  padding-right: 10px;\n}\n\n.mat-column-cooperationNameSmall {\n  width: 7% !important;\n  overflow: hidden;\n  width:auto;\n  white-space: nowrap;\n  padding-right: 10px;\n}\n\n.mat-column-numberOfUnreadMessages {\n  width: 10% !important;\n  padding-right: 10px;\n}\n\n.mat-column-workFirstNameCurrent {\n  width: 5% !important;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  width:auto;\n  white-space: nowrap;\n  padding-right: 10px;\n}\n.mat-column-timespendMin {\n  width: 5% !important;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  width:auto;\n  white-space: nowrap;\n  padding-right: 10px;\n}\n\n.mat-column-toProcessButton, .mat-column-uredi,\n.mat-column-addDaysButton, .mat-column-toHelpdeskTabButton{\n  width: 40px !important;\n  padding-right: 10px;\n}\n.mat-column-completed {\n  width: 4% !important;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  width:auto;\n  white-space: nowrap;\n  padding-right: 10px;\n}\n\nth {\n  text-overflow: ellipsis;\n}\ntable {\n  width: 100%;\n  table-layout: fixed;\n}\n}\n@media(min-width: 900px){\n  .hiddenDesktop {\n    display: none;\n  }\n    /* filter date */\n  .dateFilter {\n    width: 250px;\n  }\n}\n\n\n\n/*filter icons*/\n#filterIconCross {\n  display: inline-block;\n  width: 30px !important;\n  height: 20px;\n  -webkit-transform: rotate(0deg);\n  -moz-transform: rotate(0deg);\n  -o-transform: rotate(0deg);\n  transform: rotate(0deg);\n  -webkit-transition: .5s ease-in-out;\n  -moz-transition: .5s ease-in-out;\n  -o-transition: .5s ease-in-out;\n  transition: .5s ease-in-out;\n  cursor: pointer;\n}\n#filterIconCross span {\n  position: absolute;\n  height: 3px;\n  width: 20px;\n  background: lightcoral;\n  border-radius: 9px;\n  opacity: 1;\n  left: 0;\n  -webkit-transform: rotate(0deg);\n  -moz-transform: rotate(0deg);\n  -o-transform: rotate(0deg);\n  transform: rotate(0deg);\n  -webkit-transition: .25s ease-in-out;\n  -moz-transition: .25s ease-in-out;\n  -o-transition: .25s ease-in-out;\n  transition: .25s ease-in-out;\n}\n#filterIconCross span:nth-child(1) {\n  -webkit-transform: rotate(135deg);\n  -moz-transform: rotate(135deg);\n  -o-transform: rotate(135deg);\n  transform: rotate(135deg);\n}\n\n#filterIconCross span:nth-child(2) {\n  -webkit-transform: rotate(-135deg);\n  -moz-transform: rotate(-135deg);\n  -o-transform: rotate(-135deg);\n  transform: rotate(-135deg);\n}\n\n\n.buttonBilumina {\n  background-color:#f89624;\n  color:white;\n  margin: 10px;\n  width:90px;\n}\n\n/*table coloring*/\n#mainTable .mat-row:nth-child(odd){\n  background-color:#FFF5E3;\n  }\n\n/*table coloring*/\n#mainTable .mat-row:nth-child(even){\n  background-color:#ffe8bf;\n  }\n#mainTable .mat-row:nth-child(odd):hover{\n  transition: 0.3s;\n  background-color:#fffcf7;\n  }\n\n#mainTable .mat-row:nth-child(even):hover{\n  transition: 0.3s;\n  background-color:#ffeed0;\n  }\n\nmat-paginator {\n  background-color:#FAB565;\n}\n\n.mat-checkbox-inner-container {\n  background-color: #f89624;\n}\n\n#mainTable .mat-header-cell {\n  background-color: #f89624;\n  font-size: 16px;\n  text-align: center;\n  color: rgb(33, 29, 22);\n}\n\np:hover {\n  cursor: pointer;\n}\n\n.checkStatusColor {\n  color: #929089;\n}\n\n#overlay {\n  background: #ffffff;\n  color: #666666;\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  z-index: 5000;\n  top: 0;\n  left: 0;\n  float: left;\n  text-align: center;\n  padding-top: 25%;\n  opacity: .80;\n}\n\n.bold {\n  font-weight: bold;\n}\n\n.numReadMessages {\n  background-color: #ffb2b2  !important; /*thistle*/\n}\n\n.hidePartner {\n  display: none;\n}\n\n.mat-column-textPartner {\n  width: 30% !important;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  width:auto;\n  white-space: nowrap;\n  padding-right: 10px;\n}\n\n.mat-column-communicationTypeNameSmall {\n  width: 7% !important;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  width:auto;\n  white-space: nowrap;\n  padding-right: 10px;\n}\n.mat-column-todoCode {\n  width: 7% !important;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  width:auto;\n  white-space: nowrap;\n  padding-right: 10px;\n}\n\n.mat-column-select {\n  width: 20% !important;\n  overflow: hidden;\n  width:auto;\n  white-space: nowrap;\n  padding-right: 10px;\n}\n\n.mat-column-code {\n  width: 80% !important;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width:auto;\n  white-space: nowrap;\n  padding-right: 10px;\n}\n.statusPaddingSmallScreen {\n  padding-bottom: 15px;\n}\n\n.example-radio-group {\n  display: flex;\n  flex-direction: column;\n  margin: 15px 0;\n}\n\ntr.mat-header-row {\n  height: 40px !important;\n}\n\n.cdk-overlay-pane {\n  position: fixed !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
